<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Katun fairy tale & old traditions</h1>
    <div class='tourPic'>
      <img src='@/assets/cultours/tour6/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>The guiding idea behind creating this tour is to introduce you to one of the oldest Montenegrin traditions, encompassing various aspects of life in the mountain regions. We believe this is one of the most well-preserved expressions of a way of life that has shaped these areas for centuries.</p>
            <p class='pasus'>This semi-nomadic lifestyle is still present in many mountainous parts of central and northern Montenegro. Katuns—seasonal shepherd settlements where families stay during the summer months—are still quite numerous today, although their number is gradually declining. They may be quieter and less lively than they once were; at times, it may feel nostalgic to see only a few people and the remains of modest homes where once there were dozens. Yet, you can still feel the strength, positive energy, and authenticity that radiate from both the people and their natural surroundings.</p>
            <p class='pasus'>Proud mountain women continue to prepare delicious traditional dishes and offer genuine hospitality, while hosts gladly share stories from everyday mountain life, along with anecdotes and legends.</p>
            <p class='pasus'>Just as katuns represent one of the most authentic experiences you can have in Montenegro today, the program we create for you must remain flexible, in harmony with the rhythm of mountain life and all its unique characteristics.</p>
            <p class='pasus'>Through our many years of experience, we have met numerous people who still “move up to the mountains” (as we say in Montenegro), and we believe we can introduce you—naturally and engagingly—to how they spend their time there.</p>
            <p class='pasus'>We also recommend reading our blog, which explains in detail what katuns are and how people live in them.</p>
            <p class='pasus'>The program presented here is only an example of what a multi-day tour might look like. Depending on the timing of your visit, the desired length of your stay, your personal preferences, and the current conditions in the mountain regions, we will tailor the best possible itinerary for you.</p>
            <p class='pasus'>In addition to experiencing life in katuns, each day of your stay will also give you the opportunity to discover many other Montenegrin highlights—natural attractions, traditions, and cultural heritage.</p>
            <p class='pasus'>Welcome to the fairytale of Montenegro!</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>
              Availability: June – October
            </p>
            <p class='pasus'>Group size: 2-7</p>
            <p class='pasus'>
              Departure – From Podgorica, Tivat
            </p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 6 nights / 7 days</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
                    <ul class='collapse itinerary_days' id='itinerary'>
          <li>
            <a data-toggle='collapse' href='#day1'> <h5 class='sub-titles'>Day 1 - Towards the Northern Refreshment & Durmitor Katun</h5></a>
            <div class='collapse' id='day1'>
              <p class='pasus'>On the first day, we depart from the central or coastal region of Montenegro and head towards the much fresher, greener, and less crowded north of the country. During a few hours of driving, you will enjoy scenic landscapes and a beautiful panoramic journey. Our first stop will be in the Piva region, where we’ll take in breathtaking views of the deep canyons of the Komarnica and Piva rivers.</p>
              <p class='pasus'>We then continue along what is perhaps the most stunning panoramic road in Montenegro, crossing Durmitor Mountain. Here, we will visit a katun, taste traditional mountain specialties, and get acquainted with the katun way of life. The rest of the day is dedicated to exploring the geological features of Durmitor—admiring rock formations and enjoying spectacular viewpoints.</p>
              <p class='pasus'>Accommodation: Katun, 4-star hotel in Žabljak, or guesthouse</p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 2-3 hours</p>
                <p> <i class='fas fa-route'></i> 120-160 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour6/day1.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day2'> <h5 class='sub-titles'>Day 2 - Immersion in Durmitor National Park</h5></a>
            <div class='collapse' id='day2'>
              <p class='pasus'>The second day is dedicated to fully experiencing the beauty and atmosphere of Durmitor and its national park. We will visit Black Lake, as well as the Ćurevac viewpoint overlooking the deepest part of the Tara River canyon. You will also learn what makes the medieval tombstones so unique that they are included on the UNESCO World Heritage list.</p>
              <p class='pasus'>We will visit another katun that has been thoughtfully adapted for tourist visits, where you can enjoy activities such as horseback riding. We’ll also hear the legend of Devil’s Lake—and perhaps even take a swim in it.</p>
              <p class='pasus'>Accommodation - 4-star hotel in Žabljak or guesthouse</p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 1 hour</p>
                <p> <i class='fas fa-route'></i> 15-20 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour6/day2.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day3'><h5 class='sub-titles'>Day 3 - Tara Canyon & Biogradska Gora</h5></a>
            <div class='collapse' id='day3'>
              <p class='pasus'>On the third day, we continue exploring Durmitor National Park and the Tara River canyon. We will visit the iconic bridge built before World War II, drive through deep and dramatic landscapes, walk through impressive black pine forests, and refresh ourselves along a lively mountain stream.</p>
              <p class='pasus'>In the afternoon, we visit Biogradska Gora National Park, known for its lakes and ancient forest surrounding its jewel—Biogradsko Lake. After a relaxing walk around the lake, we continue to the charming town of Kolašin for an overnight stay.</p>
              <p class='pasus'>Accommodation - 4-star hotel in Kolašin or guesthouse</p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 2 hours</p>
                <p> <i class='fas fa-route'></i> 90 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour6/day3.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day4'><h5 class='sub-titles'>Day 4 - Sinjajevina Mountain, Katun & Jeep Safari</h5></a>
            <div class='collapse' id='day4'>
              <p class='pasus'>This day is dedicated to Sinjajevina Mountain, famous for its incredible viewpoints, vast pastures, and still-active katun lifestyle.</p>
              <p class='pasus'>We will enjoy a jeep safari and visit a katun that continues to preserve the spirit of past times. On our way down the mountain, we will take in spectacular views of the valleys surrounding the town of Kolašin.</p>
              <p class='pasus'>Accommodation - 4-star hotel in Kolašin or guesthouse</p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3-4 hours</p>
                <p> <i class='fas fa-route'></i> 50 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour6/day4.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day5'><h5 class='sub-titles'>Day 5 - Komovi Region & Eastern Montenegro</h5></a>
            <div class='collapse' id='day5'>
              <p class='pasus'>On the final full day of the program, we head to a different region—multiethnic areas near the borders with Albania and Kosovo. We will visit Komovi Nature Park, one of the most beautiful mountain areas in Montenegro, and a katun on its slopes where blueberry juice and liqueur are a must-try refreshment.</p>
              <p class='pasus'>We will also visit Lake Plav, the largest glacial lake in Montenegro, with the possibility of swimming. Additional highlights include Ali Pasha’s springs, the striking “Eye of Skakavica” known for its vivid blue color, and the towns of Plav and Gusinje, where authentic architecture from another era is still preserved in places.</p>
              <p class='pasus'> </p>
              <p class='pasus'>Accommodation - 4-star hotel in Kolašin or guesthouse </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3-4 hours</p>
                <p> <i class='fas fa-route'></i> 150 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour6/day5.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day6'><h5 class='sub-titles'>Day 6 - Moraca canyon and beauty of the old Montenegro</h5></a>
            <div class='collapse' id='day6'>
              <p class='pasus'>It’s time to gradually return to central Montenegro. The journey takes us through the impressive Morača River canyon, where we will visit the historic Morača Monastery, renowned for its frescoes and icons and known as a centuries-old guardian of tradition.</p>
              <p class='pasus'>We then continue to the historic royal capital of Cetinje, followed by a spectacular panoramic drive around Mount Lovćen, offering unforgettable views of the Bay of Kotor.</p>
              <p class='pasus'> </p>
              <p class='pasus'>Accommodation - 4-star hotel in Cetinje, Podgorica, or guesthouse </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3.5 hours</p>
                <p> <i class='fas fa-route'></i> 180 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour6/day6.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day7'><h5 class='sub-titles'>Day 7 - Departure Day</h5></a>
            <div class='collapse' id='day6'>
              <p class='pasus'>On your final morning, you will enjoy breakfast as usual. Afterward, our driver will collect your luggage, and we will transfer you directly to the airport.</p>
            </div>
          </li>
          </ul>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'>
            <h4 class='titles'>Prices (based on the number of people in your group):</h4>
          </a>
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>2 persons – 1650 EUR p/person</li>
              <li class='pasus'>4 persons – 1300 EUR p/person</li>
              <li class='pasus'>6 persons – 1200 EUR p/person</li>
              <li class='pasus'>Single room supplement: 250 EUR.</li>
              <li class='pasus'>TOUR DATES: On request</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Accommodation for all nights</li>
              <li class='pasus'>Transportation (van or car)</li>
              <li class='pasus'>Breakfast and dinner for all days</li>
              <li class='pasus'>Lunch on days 1 and 4</li>
              <li class='pasus'>Prosciutto & Cheese testing</li>
              <li class='pasus'>Pick up at the airport</li>
              <li class='pasus'>Transfer to the airport on the last day</li>
              <li class='pasus'>Bottle of water (0,5l) on each day</li>
              <li class='pasus'>Entrance fees for all national parks</li>
              <li class='pasus'>Our assistance 24/7</li>
              <li class='pasus'>Licensed tour guide</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
            <a data-toggle='collapse' href='#notincluded'> <h4 class='titles'>Not included in price:</h4></a>
            <div class='collapse' id='notincluded'>
              <ul class='square'>
                <li class='pasus'>Options as mentioned</li>
                <li class='pasus'>Drinks and tips</li>
                <li class='pasus'>Personal expenses</li>
              </ul>
            </div>
          </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>We recommend always bringing a jacket, hat, sunglasses, appropriate footwear for mountain conditions, and a swimsuit. Weather in mountainous areas can change frequently.</li>
              <li class='pasus'>Prices in restaurants and bars are very affordable.</li>
              <li class='pasus'>The local currency is Euro (€). </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional activities:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Panoramic cable car ride (8 EUR per person)</li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>Changes to the itinerary during the tour upon agreement (no impact on the price)</li>
              <li class='pasus'>Zip line over the Tara Canyon (ticket: 30 EUR)</li>
              <li class='pasus'>Boat or canoe rental on Biogradsko Lake or Black Lake (1 hour: 8 EUR)</li>
              <li class='pasus'>Horse riding (1 hour: 25–30 EUR)</li>
              <li class='pasus'>Rafting (70 EUR per person)</li>
              <li class='pasus'>Canyoning (130 EUR per person)</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/cultours/tour6/01.jpg'),
          thumbnail: require('@/assets/cultours/tour6/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/02.jpg'),
          thumbnail: require('@/assets/cultours/tour6/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/03.jpg'),
          thumbnail: require('@/assets/cultours/tour6/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/04.jpg'),
          thumbnail: require('@/assets/cultours/tour6/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/05.jpg'),
          thumbnail: require('@/assets/cultours/tour6/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/06.jpg'),
          thumbnail: require('@/assets/cultours/tour6/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/07.jpg'),
          thumbnail: require('@/assets/cultours/tour6/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/08.jpg'),
          thumbnail: require('@/assets/cultours/tour6/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/09.jpg'),
          thumbnail: require('@/assets/cultours/tour6/09.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/10.jpg'),
          thumbnail: require('@/assets/cultours/tour6/10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/11.jpg'),
          thumbnail: require('@/assets/cultours/tour6/11.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/12.jpg'),
          thumbnail: require('@/assets/cultours/tour6/12.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/13.jpg'),
          thumbnail: require('@/assets/cultours/tour6/13.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour6/14.jpg'),
          thumbnail: require('@/assets/cultours/tour6/14.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/CT6_KatunFairyTale.vue